import { Box, Typography } from '@mui/material';
import isEqual from 'lodash/isEqual';
import { func, object } from 'prop-types';
import React, { memo, useCallback } from 'react';

export const toColorValue = input => {
  const raw = typeof input === 'string' ? input : input?.hex || '';
  const hex = String(raw).replace('#', '') || '999999';
  return { hex };
};

const FormikColorPicker = ({
  field,
  bindChange = () => {},
  form,
  disabled,
  onBlur: onBlurProp,
  id,
}) => {
  const { name, value, onBlur } = field;
  const { setFieldValue } = form;
  const hex = toColorValue(value).hex;
  const handleBlur = useCallback(
    e => {
      onBlur(e);
      if (onBlurProp) {
        onBlurProp(e);
      }
    },
    [onBlur, onBlurProp],
  );
  const handleChange = useCallback(
    event => {
      const color = toColorValue(event.target.value);
      bindChange(color);
      setFieldValue(name, color);
    },
    [bindChange, name, setFieldValue],
  );
  return (
    <Box sx={{ '& > div': { alignItems: 'center' } }}>
      {disabled ? (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box
            sx={{
              width: 24,
              minHeight: 24,
              borderRadius: 0.5,
              backgroundColor: `#${hex}`,
            }}
          />
          <Typography>{`#${hex}`}</Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component="input"
            type="color"
            id={id}
            onChange={handleChange}
            onBlur={handleBlur}
            value={`#${hex}`}
            name={name}
            aria-label={name}
            sx={{
              width: 40,
              height: 32,
              padding: 0,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
            }}
          />
          <Typography>{`#${hex}`}</Typography>
        </Box>
      )}
    </Box>
  );
};
FormikColorPicker.propTypes = {
  field: object.isRequired,
  form: object.isRequired,
  bindChange: func,
  onBlur: func,
};
const areEqual = (
  { form: { submitCount, errors }, field: { name, value }, type, disabled, InputProps },
  {
    form: { submitCount: newSubmitCount, errors: nextErrors },
    field: { value: nextValue },
    type: nextType,
    disabled: nextDisabled,
    InputProps: nextInputProps,
  },
) => {
  return (
    submitCount === newSubmitCount &&
    value === nextValue &&
    errors[name] === nextErrors[name] &&
    type === nextType &&
    disabled === nextDisabled &&
    isEqual(InputProps, nextInputProps)
  );
};
export default memo(FormikColorPicker, areEqual);
